import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const vehicles = {
    state: {
        vehicles: null,
        vehicleInputData: null,
        showAddVehicleForm: false,
        showTruckModal: false,
        showTrailerModal: false,
        showTankCarModal: false
    },

    mutations: {
        setVehicles(state, vehicles){
            state.vehicles = vehicles
        },
        setInputData(state, payload){
            state.vehicleInputData = payload
        },
        showAddVehicleForm(state){
            state.showAddVehicleForm = true
        },
        hideAddVehicleForm(state){
            state.showAddVehicleForm = false
        },
        showTruckModal(state){
            state.showTruckModal = true
        },
        showTrailerModal(state){
            state.showTrailerModal = true
        },
        showTankCarModal(state){
            state.showTankCarModal = true
        },
        hideAllModals(state){
            state.showTruckModal = false
            state.showTrailerModal = false
            state.showTankCarModal = false
        }
    },

    actions: {
        getVehicles({ commit, rootState, dispatch, state }, page){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/search_vehicles?page='+page +'&q='+rootState.search)
                    .then(response => {
                        commit('setVehicles', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getVehicleInputData({ commit, rootState, dispatch }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/vehicles/create')
                    .then(response => {
                        commit('setInputData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        createNewVehicle({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/vehicles', {
                    reg_nr: formData.regNr,
                    year: formData.year,
                    vehicle_type_id: formData.typeId,
                    owner_id: formData.ownerId,
                    manufacturer: formData.manufacturer,
                    model: formData.model,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getVehicles')
                        commit('hideAddVehicleForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        createNewVehicleFromModal({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/vehicles', {
                    reg_nr: formData.regNr,
                    year: formData.year,
                    vehicle_type_id: formData.typeId,
                    owner_id: formData.ownerId,
                    manufacturer: formData.manufacturer,
                    model: formData.model,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getCleaningInputData')
                        commit('hideAllModals')
                        vm.$Progress.finish()
                        dispatch('setSnackbar', {
                            color: 'green',
                            text: 'Transporta līdzeklis pievienots'
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        deleteVehicle({commit, rootState, dispatch, state}, vehicleId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/vehicles/'+vehicleId)
                    .then(response => {
                        dispatch('getVehicles')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        showAddVehicleForm({ commit }){
            commit('showAddVehicleForm')
        },
        hideAddVehicleForm({ commit }){
            commit('hideAddVehicleForm')
        },
        showTruckModal({ commit }){
            commit('showTruckModal')
        },
        showTrailerModal({ commit }){
            commit('showTrailerModal')
        },
        showTankCarModal({ commit }){
            commit('showTankCarModal')
        },
        hideAllModals({ commit }){
            commit('hideAllModals')
        },
    },
    getters: {
        vehicles(state){
            return state.vehicles
        },
        vehicleInputData(state){
            return state.vehicleInputData
        },
        showAddVehicleForm(state){
            return state.showAddVehicleForm
        },
        showTruckModal(state){
            return state.showTruckModal
        },
        showTrailerModal(state){
            return state.showTrailerModal
        },
        showTankCarModal(state){
            return state.showTankCarModal
        },

    }
}

export default vehicles